module.exports = __webpack_public_path__ + "img/mango-1.fa172ca5.png";